'use client'

import React from 'react'

/** Shared styling + success state for the marketing forms (Contact, Careers). */

export const FC = {
  ink: '#0a0a0b',
  mute: '#7a7468',
  line: 'rgba(0,0,0,0.12)',
  purple: '#7c5cff',
  good: '#10b981',
  bad: '#ef4444',
} as const

export const inputStyle: React.CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  padding: '11px 13px',
  borderRadius: 10,
  border: `1px solid ${FC.line}`,
  background: '#fff',
  fontSize: 14.5,
  color: FC.ink,
  fontFamily: 'inherit',
  outline: 'none',
}

export const labelStyle: React.CSSProperties = {
  display: 'block',
  fontSize: 13,
  fontWeight: 600,
  color: FC.ink,
  marginBottom: 6,
}

export const submitStyle = (sending: boolean): React.CSSProperties => ({
  height: 46,
  borderRadius: 12,
  border: 'none',
  background: FC.ink,
  color: '#fff',
  fontSize: 14.5,
  fontWeight: 600,
  cursor: sending ? 'default' : 'pointer',
  fontFamily: 'inherit',
  opacity: sending ? 0.7 : 1,
})

export function FormSuccess({ title, body }: { title: string; body: string }) {
  return (
    <div style={{ textAlign: 'center', padding: '24px 0' }}>
      <div style={{ width: 44, height: 44, borderRadius: '50%', background: `${FC.good}1a`, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 }}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={FC.good} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 6L9 17l-5-5" />
        </svg>
      </div>
      <h3 style={{ fontSize: 18, fontWeight: 600, margin: '0 0 6px', color: FC.ink }}>{title}</h3>
      <p style={{ fontSize: 14.5, color: FC.mute, margin: 0 }}>{body}</p>
    </div>
  )
}

/** Off-screen honeypot field — real users never fill it. */
export function Honeypot({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  return (
    <div aria-hidden="true" style={{ position: 'absolute', left: '-9999px', width: 1, height: 1, overflow: 'hidden' }}>
      <label htmlFor="hp-company">Company</label>
      <input id="hp-company" tabIndex={-1} autoComplete="off" value={value} onChange={(e) => onChange(e.target.value)} />
    </div>
  )
}
